import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["applyButton"];

  reloadCharts(event) {
    event.preventDefault();
    this.applyButtonTarget.textContent = "Processing...";
    this.applyButtonTarget.disabled = "disabled";

    let chartLinks = document.getElementsByClassName("reloadable-chart");
    for (let link of chartLinks) {
      link.dispatchEvent(new Event("click"));
    }
  }
}
